/**
 * The publishable key of the Squelette `baback` workspace.
 *
 * It has its own name because the deploy workflows set the build environment
 * once for the whole monorepo: track-office reads `VITE_SQUELETTE_KEY`, which
 * carries the `baback-tracking` workspace, and a shared name would give both
 * apps the same changelog.
 *
 * Absent, Vite replaces it with `undefined`, the components become dead code
 * and the bundler drops them entirely.
 */
export const squeletteKey = import.meta.env.VITE_SQUELETTE_OFFICE_KEY;
